var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crown-button',_vm._g({attrs:{"id":"lane-above-button","aria-label":"Add lane above icon","src":_vm.laneAboveIcon,"width":25}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }